import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { QueryErrorBoundary } from '@/components/query/QueryErrorBoundary';
import { ClientItemDetail } from '@/features/audit-binders/client/ClientItemDetail';

export const Route = createFileRoute('/audit-binders/$binderId/items/$itemId')({
  errorComponent: QueryErrorBoundary,
  component: ClientItemDetailRoute,
});

function ClientItemDetailRoute() {
  const { binderId, itemId } = Route.useParams();
  const theme = useTheme();
  // The full-screen item view exists only for mobile. On desktop we redirect
  // to the binder index with ?item=... so the two-pane workspace shows the
  // item in its side panel — same component the staff use.
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const navigate = useNavigate();

  useEffect(() => {
    if (!isDesktop) return;
    navigate({
      to: '/audit-binders/$binderId',
      params: { binderId },
      search: { item: itemId },
      replace: true,
    });
  }, [isDesktop, binderId, itemId, navigate]);

  if (isDesktop) return <Box sx={{ height: 'calc(100vh - 64px)' }} />;

  return (
    <Box sx={{ height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
      <ClientItemDetail binderId={binderId} itemId={itemId} />
    </Box>
  );
}
